package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_request_data_di_RequestModule : Module get() = module {
	single() { _ -> com.essntl.features.request.data.repository.RequestRepositoryImpl(supabase=get()) } bind(com.essntl.features.request.domain.repository.RequestRepository::class)
	single() { _ -> com.essntl.features.request.data.supabase.RequestSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.request.data.supabase.RequestSupabaseDataSource::class)
}
public val com.essntl.features.request.data.di.RequestModule.module : org.koin.core.module.Module get() = com_essntl_features_request_data_di_RequestModule
